import { render, staticRenderFns } from "./CoursesLectures.vue?vue&type=template&id=022d6220&scoped=true"
import script from "./CoursesLectures.vue?vue&type=script&lang=ts"
export * from "./CoursesLectures.vue?vue&type=script&lang=ts"
import style0 from "./CoursesLectures.vue?vue&type=style&index=0&id=022d6220&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d6220",
  null
  
)

export default component.exports